import React, {useState} from "react";
import sha256 from 'js-sha256'
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'
//import {format} from 'date-fns'
import {useSelector} from 'react-redux'
import {numerologyReportTypes} from '../services/functions'


export default function ReportGenNumerologySection(props) {

    const navigate = useNavigate();

    const currentCustomer = useSelector(state => state.currentCustomer)

    const hash = sha256(currentCustomer.user.email);
    const accessToken = localStorage.getItem("accessToken");
    const addNumerologyReportUrl = `${process.env.REACT_APP_CSAPI_BASE_URL}/numerology/add?hash=${hash}`;
    
    const [buttonText, setButtonText] = useState('Generate');
    const [showSpinner, setShowSpinner] = useState('visually-hidden');

    const [alertStatus, setAlertStatus] = useState({
		status: false,
		message: '',
        errorMessage: [],
	});

    const [reportSent, setReportSent] = useState(false)

    const [numReportInput, setNumReportInput] = useState({		
		numrptype: 0,
        birthFName: '',
        birthMName: '',
        birthLName: '',
        cMFName: '',
        cMMName: '',
        cMLName: '',
    })
   
    const modalLoaded = () => {
        setReportSent(false)
        setButtonText("Generate")
        setShowSpinner("visually-hidden")
    };

    let numerologyReportTypesList = numerologyReportTypes.length > 0
		&& numerologyReportTypes.map((item, i) => {
		return (
			<option key={i} value={item.value}>{item.label}</option>
		)
	}, this)

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setNumReportInput({
			...numReportInput,
            [name]: value
		})
    }

    const mtrim = (str) => {
        return str.replace(/^\s+|\s+$/g,'');
    }

    const checkParenthesis = (a) => {
        let count=1;let x=0;while(x<a.length){if(a[x]==="("){count++;}
        if(a[x]===")"){count--;}
        x++;if(count<1||count>2){return false;}}
        if(count!==1){return false;}
        return true;
    }

    const invalidParenthesis = (fieldnval) => {
        let f_value=fieldnval
                
        let patt=/[(][s]*[)]/;
        
        if(patt.test(f_value))
        {
            return true;
        }
        return false;
    }

    
    const invalidParenthesis2 = (fieldnval) => {
        
        let f_value = mtrim(fieldnval);
        
        let temp_str = f_value.split(" ");
        let temp_var = 0;
        while (temp_var < temp_str.length) {
            if (!checkParenthesis(temp_str[temp_var])) {
                return true;
            }
            temp_var++;
        }
        return false;
    }
    
    const invalidApostrophe = (fieldnval) => {        
        let f_value = fieldnval
        let patt = /[`][s]*[`]/;
        if (patt.test(f_value)) {
            return true;
        }
        return false;
    }    

    const invalidDash = (fieldnval) => {
        let f_value = fieldnval
        let patt = /[-][s]*[-]/;
        if (patt.test(f_value)) {
            return true;
        }
        return false;
    }

    const validateFnameLname = (fieldname,fieldvalue) => {
        let re = /^[A-Z a-z-_.`( )]+$/;
        let reB = /^[A-Z a-z]+$/;
        let reC = /^[-_.`]+$/;

        let str = ""
        let resA = ""
        let resB = ""

        if (fieldvalue === "" || fieldvalue === null) {
            return `Please enter your ${fieldname} Name`
        } else {
            
            if (!re.test(fieldvalue)) {
                return `Please enter a valid ${fieldname} Name, use only alphabetic value.`
            }

            str = fieldvalue;
            resA = str.charAt(0);
            resB = str.charAt(1);
            
            //let reA = /^.*s{2,}.*$/;
        
            if (str.split("  ").length - 1 > 0) {
                return "Only 1 space is allowed"
            } else if (invalidParenthesis(fieldvalue) || invalidParenthesis2(fieldvalue)) {
                return `Please enter a valid ${fieldname} Name. please use valid Parenthesis.`
            } else if (invalidApostrophe(fieldvalue) || invalidDash(fieldvalue)) {
                return 'Invalid characters' 
            } 

            if (resA === "(") {
                
                if (!reB.test(resB)) {
                    return `The first character entered for the ${fieldname} name must be a letter, or ( followed by a letter (the left parenthesis character followed by a letter)`
                }
            } else {
                
                if (reC.test(resA)) {
                    return `The first character entered for the ${fieldname} name must be a letter, or ( followed by a letter (the left parenthesis character followed by a letter`
                }
            }            
        }

        return ""
    }

    const validateMiddleName = (fieldname,fieldvalue) => {
        let re = /^[A-Z a-z-_.`( )]+$/;
        let reB = /^[A-Z a-z]+$/;
        let reC = /^[-_.`]+$/;

        
        let str = ""
        let resA = ""
        let resB = ""

        if (fieldvalue !== "") {
            
            if (!re.test(fieldvalue)) {
                return `Please enter a valid ${fieldname} Middle Name, use only alphabetic value.`
            }

            str = fieldvalue;
            resA = str.charAt(0);
            resB = str.charAt(1);
            
            //let reA = /^.*s{2,}.*$/;
        
            if (str.split("  ").length - 1 > 0) {
                return 'Only 1 space is allowed'
            }else if (invalidParenthesis(str) || invalidParenthesis2(str)) {
                return 'Please enter a valid Birth Middle Name. please use valid Parenthesis.'
            } else if (invalidApostrophe(str) || invalidDash(str)) {
                return 'Invalid characters'
            }

            if (resA === "(") {
                
                if (!reB.test(resB)) {
                    return `The first character entered for the ${fieldname} name must be a letter, or ( followed by a letter (the left parenthesis character followed by a letter`
                }
            } else {
                
                if (reC.test(resA)) {
                    return `The first character entered for the ${fieldname} name must be a letter, or ( followed by a letter (the left parenthesis character followed by a letter`
                }
            }
        }
        return ""
    }


    const postNumerologyReport = (URl, postData) => {        

        axios.post(URl, postData, {
			headers: {
				'Authorization': `Bearer ${accessToken}`
			},
		})
		.then(result => {
            if(result.data.status === 'success')
			{
                setShowSpinner("visually-hidden")
                setButtonText("Generate")
                setReportSent(true)
            }
         })
		.catch((error) => {
			// Error
			if(error.response.status === 401)
			{
				localStorage.clear()
      	        navigate("/login")
			}
		})
	}
    

    const handleRequestSend = () => {

        let message = []

        setAlertStatus({
            ...alertStatus,
            'status': false,            
            'errorMessage': ''
        })

        if (numReportInput.numrptype === 0 || isNaN(numReportInput.numrptype)) {
			message.push("Please select report type")
		}      

        if(currentCustomer.user.birthDay === ""  || currentCustomer.user.birthDay === "0000-00-00" || currentCustomer.user.birthDay === "1900-01-01") {
            message.push("Date of Birth is not correct. Please update in customer section")
        }

        let BirthFName_val = numReportInput.birthFName
        let BirthMName_val = numReportInput.birthMName
        let BirthLName_val = numReportInput.birthLName
        let CmFName_val = numReportInput.cMFName
        let CmMName_val = numReportInput.cMMName
        let CmLName_val = numReportInput.cMLName

        

        //console.log(validateFnameLname("First",BirthFName_val))
        if(validateFnameLname("Birth First",BirthFName_val) !== "") {
            message.push(validateFnameLname("Birth First",BirthFName_val))
        }
        if(BirthMName_val !== "" && validateMiddleName("Birth Middle",BirthMName_val) !== "") {
            message.push(validateMiddleName("Birth Middle",BirthMName_val))
        }
        if(validateFnameLname("Birth Last",BirthLName_val) !== "") {
            message.push(validateFnameLname("Birth Last",BirthLName_val))
        }

        if(validateFnameLname("Commonly used First",CmFName_val) !== "") {
            message.push(validateFnameLname("Commonly used First",CmFName_val))
        }
        if(CmMName_val !== "" && validateMiddleName("Commonly used Middle",CmMName_val) !== "") {
            message.push(validateMiddleName("Commonly used Middle",CmMName_val))
        }
        if(validateFnameLname("Commonly used Last",CmLName_val) !== "") {
            message.push(validateFnameLname("Commonly used Last",CmLName_val))
        }
             
        setAlertStatus({
            ...alertStatus,
            'status': (message.length > 0 ? true : false),
            'errorMessage': message
        })

        let fullbirthname = ''
        let fullcommonlyname = ''

        if(mtrim(BirthMName_val) !== "") {
            fullbirthname = `${mtrim(BirthFName_val)} ${mtrim(BirthMName_val)} ${mtrim(BirthLName_val)}`
        } else {
            fullbirthname = `${mtrim(BirthFName_val)} ${mtrim(BirthLName_val)}`
        }

        if(mtrim(CmMName_val) !== "") {
            fullcommonlyname = `${mtrim(CmFName_val)} ${mtrim(CmMName_val)} ${mtrim(CmLName_val)}`
        } else {
            fullcommonlyname = `${mtrim(CmFName_val)} ${mtrim(CmLName_val)}`
        }
        
        if(message.length === 0) {
            setButtonText("Sending Request")
            setShowSpinner("")
            let numerologyPostData = {fullName: fullbirthname, commonlyName: fullcommonlyname, dob: currentCustomer.user.birthDay, status: 0, isAdmin: 1, type: numReportInput.numrptype}
            postNumerologyReport(addNumerologyReportUrl,numerologyPostData)
        }
        
    }

    return (
        <>
        <div>
            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered 
                show={props.numerologyShow} 
                onHide={() => props.onHide({ msg: 'Icon Clicked!' })}
                onEntered={modalLoaded}
            >
            <Modal.Header closeButton>
                <Modal.Title>
                    {props.numerologyTitle}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="app-card app-card-orders-table mb-5">
                    <div className="app-card-body">
                        <div className="row">
                        {alertStatus.status ? (
                            <div className="w-100">
                                <div className={`alert alert-danger fade show ms-4 me-4`}>

                                {alertStatus.errorMessage.map((messageData,i) => {
                                    return (
                                        <ul key={i}>
                                            <li className="fw-bold">{messageData}</li>
                                        </ul>
                                    )
                                })}                                   
                                    
                                </div>
                            </div>
                        ) : '' }
                            <h5>Report Type</h5>
                            <div className="form_group">
                                <select name="numrptype" 
                                    className="form-select" 
                                    onChange={(e) =>
                                                setNumReportInput({
                                                ...numReportInput,
                                                [e.target.name]: parseInt(e.target.value)
                                                })
                                }>
                                    {numerologyReportTypesList}
                                </select>
                            </div>
                        </div>
                        <div className="clearb"></div>
                        <div className="row mt-4">
                            <h5>Full Name Given At Birth</h5>
                            <div className="col">
                                <input type="text" className="form-control" name="birthFName" onChange={handleInputChange} />
                                <label>First</label>
                            </div>
                            <div className="col">
                                <input type="text" className="form-control" name="birthMName" onChange={handleInputChange} />
                                <label>Middle(s)</label>
                            </div>
                            <div className="col">
                                <input type="text" className="form-control" name="birthLName" onChange={handleInputChange} />
                                <label>Last</label>
                            </div>
                        </div>
                        <div className="clearb"></div>
                        <div className="row mt-4">
                            <h5>Full Name Most Commonly Used Today </h5>
                            <div className="col">
                                <input type="text" className="form-control" name="cMFName" onChange={handleInputChange} />
                                <label>First</label>
                            </div>
                            <div className="col">
                                <input type="text" className="form-control" name="cMMName" onChange={handleInputChange} />
                                <label>Middle(s) if used</label>
                            </div>
                            <div className="col">
                                <input type="text" className="form-control" name="cMLName" onChange={handleInputChange} />
                                <label>Last</label>
                            </div>
                        </div>
                        <div className="clear"></div>
                        <div className="row mt-4">                            
                            <div className="form_group">
                                <button type="submit" className="btn btn-primary" onClick={handleRequestSend}>
                                    <span className={`spinner-grow spinner-grow-sm me-1 ${showSpinner}`}></span>
                                    <span className="">{buttonText}</span>
                                </button>
                                {reportSent ? <span className="mx-1 text-success">Your Report Request Has Been Sent. Please check after sometime.</span> : ''}
                            </div>
                        </div>
                    </div>
                </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => props.onClick({ msg: 'Modal Closed!' })} >Close</Button>                        
                </Modal.Footer>

            </Modal>
        </div>
        </>
    )
}